import Vue from "vue";
import axios from "axios";

const state = Vue.observable({
  appConfig: {},
  backofficeAppConfig: {},
  isLoaded: false,
  isLoading: false,
  error: null,
});

let initializePromise = null;

function normalizeBaseUrl(value) {
  return String(value || "").replace(/\/+$/, "");
}

function getFeaturePlatforms(featureName) {
  const features =
    (state.backofficeAppConfig && state.backofficeAppConfig.features) || {};
  const feature = features[featureName];
  if (!feature || typeof feature !== "object") {
    return [];
  }

  const platforms = feature.platforms || {};
  return Object.keys(platforms)
    .map((platformKey) => platforms[platformKey])
    .filter((platformConfig) => platformConfig && typeof platformConfig === "object");
}

const appConfigFeatureService = {
  state,

  async initialize(forceRefresh = false) {
    if (state.isLoaded && !forceRefresh) {
      return state.appConfig;
    }

    if (initializePromise && !forceRefresh) {
      return initializePromise;
    }

    initializePromise = this.fetchAppConfig()
      .catch(() => state.appConfig)
      .finally(() => {
        initializePromise = null;
      });

    return initializePromise;
  },

  async fetchAppConfig() {
    const baseUrl = normalizeBaseUrl(process.env.VUE_APP_BACKEND_URL);
    if (!baseUrl) {
      state.isLoaded = true;
      state.error = null;
      return state.appConfig;
    }

    state.isLoading = true;
    state.error = null;

    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${baseUrl}/api/v2/app/config`, {
        headers: {
          Accept: "application/json",
          ...(token ? { Authorization: token } : {}),
        },
      });

      const payload =
        response && response.data && typeof response.data === "object"
          ? response.data
          : {};

      state.appConfig = payload;
      state.backofficeAppConfig =
        payload.backoffice_app && typeof payload.backoffice_app === "object"
          ? payload.backoffice_app
          : {};
      state.isLoaded = true;
      return payload;
    } catch (error) {
      state.error = error;
      state.isLoaded = true;
      return state.appConfig;
    } finally {
      state.isLoading = false;
    }
  },

  isFeatureEnabled(featureName, options = {}) {
    const { defaultValue = true } = options;
    const platforms = getFeaturePlatforms(featureName);
    if (!platforms.length) {
      return defaultValue;
    }

    return platforms.some((platformConfig) => platformConfig.enabled === true);
  },
};

export default appConfigFeatureService;
